module.exports = __webpack_public_path__ + "img/lilie_lp4142.55326764.png";